module.exports = __webpack_public_path__ + "static/img/menu_2.7d4d6aff.jpg";